import Layout from "@/layout"
export default [
  {
    path: "/", 
    redirect: "/dashboard",
    component: Layout,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        meta: {
          title: "首页", //meta里面也要有title 用于面包屑上使用
          affix: true,
          showFooter: true,
          icon: "home"
        },
        component: () => import(/* webpackChunkName: "constantModule" */"@/views/dashboard")
      },
      {
        path: "/redirect/:path(.*)",
        name: "redirect",
        meta: {},
        hidden: true,
        component: () => import(/* webpackChunkName: "constantModule" */"@/views/constant/redirect")
      },
      {
        path: "/login",
        name: "login",
        meta: {
          title: "登录", 
          unNeedLogin: true
        },
        component: () => import(/* webpackChunkName: "constantModule" */"@/views/constant/login"),
        hidden: true
      }
    ]
  }
]